import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Header from "Components/Header";
import Footer from "Components/Footer";
import { useHistory } from "react-router-dom";
import CorrectorEditor from "Components/CorrectorEditor";
import { fixoApi } from "Api";

const CorrectorEditorList = ({
  match: {
    params: { id },
  },
}) => {
  const [originArr, setOriginArr] = useState([]); // 유저가 쓴 원본
  const [revisionArr, setRevisionArr] = useState([]); // 첨삭 후 수정본
  const [specific, setSpecific] = useState([]);
  const history = useHistory();

  const getOriginData = async () => {
    const res = await fixoApi.getCorrectData(id);
    const clearData = JSON.parse(JSON.stringify(res)); //원본 데이터 참조를 제거 후 복사
    console.log(res);
    setOriginArr(res.data.statement); //원본 데이터를 originArr state에 저장
    setRevisionArr(clearData.data.statement); // 참조 제거된 원본 데이터를 revisionArr state에 저장
    setSpecific(clearData.data.specified_id);
  };

  const submitHandler = async (type) => {
    await fixoApi.correctorSubmit(revisionArr, specific, type);
    sessionStorage.setItem("specific", specific);
    history.push(`/result/${id}`);
  }; // 백엔드에 첨삭자가 수정한 데이터 전달하는 onclick 함수

  useEffect(() => {
    getOriginData();
    window.scrollTo(0, 0);
    // eslint-disable-next-line
  }, []);
  return (
    <Container>
      <Header />
      <Main>
        {revisionArr.length > 0 &&
          revisionArr.map((el) => (
            <CorrectorEditor
              key={el.id - 1}
              id={el.id - 1}
              setRevisionArr={setRevisionArr}
              revisionArr={revisionArr}
              originText={originArr[el.id - 1].answer}
              specific={specific}
            />
          ))}
        <ButtonWrap>
          <button onClick={() => submitHandler(0)}>저장하기</button>
          <button onClick={() => submitHandler(1)}>제출하기</button>
        </ButtonWrap>
      </Main>
      <Footer />
    </Container>
  );
};

export default CorrectorEditorList;

const Container = styled.div`
  position: relative;
  min-height: 100vh;
  padding-bottom: 250px;
`;

const Main = styled.section`
  max-width: 1200px;
  margin: 0px auto;
  position: relative;
  min-height: 100vh;
  padding-bottom: 250px;
`;

const ButtonWrap = styled.div`
  display: flex;
  justify-content: flex-end;
  margin: 100px 50px 0 0;

  button {
    width: 170px;
    height: 60px;
    margin-right: 10px;
    border-radius: 10px;
    background-color: #7903d4;
    border-style: none;
    font-weight: 600;
    font-size: 19px;
    color: white;
    cursor: pointer;
    outline: none;
    transition: opacity 0.1s linear;
    &:hover {
      opacity: 0.9;
    }
  }
`;
